module.exports = __webpack_public_path__ + "static/img/bid-banner.0ab4b3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bid-banner.png
// module id = W1vL
// module chunks = 1